/**
 * QuickEmailContext — shared React context object.
 * Lives in its own module so both QuickEmailProvider (component) and
 * useQuickEmail (hook) can import it without tripping the
 * react-refresh/only-export-components rule.
 */
import { createContext } from 'react'

export const QuickEmailContext = createContext(null)
